export default {
    SERVICE:"service"
}
